import LogUtilisateursServices from "@/app/services/admin/LogUtilisateurs.services";
import UserService from "@/app/services/admin/User.service";

let today = new Date();
let email = ""

// Function to get user data (First name and Last name)
const getUserDados = async(userID) => {
  const getDonneeUser = await UserService.userStudentGetcodeIDSeulement(userID, "pesquisaUserID-IDseulement");
  /* 
  firstName = getDonneeUser.data.firstname;
  lastName = getDonneeUser.data.lastname;
  email = getDonneeUser.data.email; */

  // console.log("getDonneeUser.data######: ", getDonneeUser.data);
}

// Function to get IP and Location data using ipinfo.io API
async function getUserLocationData() {
  try {
    const response = await fetch('https://ipinfo.io/json?token=6e75ba1a579b62'); // Replace with your token
    const data = await response.json();
    
    // Extracting information
    const { ip, city, country, loc } = data; // 'loc' contains latitude and longitude as a string
    const [latitude, longitude] = loc.split(',');

    // Returning the data
    return {
      ip,
      city,
      country,
      latitude,
      longitude
    };
  } catch (error) {
    console.error("Error fetching IP/location data:", error);
    return {
      ip: '',
      city: '',
      country: '',
      latitude: '',
      longitude: ''
    };
  }
}

// Function for user disconnection and logging the event
export async function deconnection(userID, salleDeliberatio, toutLeSystemn, firstName, lastName) 
{
  try {

  // console.log("toutLeSystemn ####### ", toutLeSystemn);
  // console.log("userID111111111 ####### ", userID)

  // await getUserDados(userID);

  const userEnLignesalleDeliberation = {
    enligne: 0,
    enlignesalledeliberation: salleDeliberatio,
    date: new Date(),
    heureconnexionsalledeliberation: today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds(),
    datedeconnexionsalledeliberation: new Date(),
    disconectBeforeConnect : 0,
    tipo: "deconnexion du logiciel",
    userID
  };

  await UserService.update(userID, userEnLignesalleDeliberation);

    // Get user data (First name and Last name)

    // Get IP and Location data
    const locationData = await getUserLocationData();

    const userDados = {
      data: today,
      hora: today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds(),
      formulario: "deconnexion",
      evento: "deconnexion",
      userID: userID,
      firstname: firstName,
      lastname: lastName,
      adressip: locationData.ip,
      paysLocalisation: locationData.country,
      villelocalisation: locationData.city,
      latitude: locationData.latitude,
      longitude: locationData.longitude
    };
    
    // Save log data
    await LogUtilisateursServices.create(userDados);

    return "ok";
  } catch (error) {
    console.error("Error during deconnection:", error);
  }
}

// Function to log any event in the system
export async function logUtilisateurs(userID, formulaire, evenement, firstName, lastName ) {
  try {
    // Get user data (First name and Last name)
     // await getUserDados(userID);

    // Get IP and Location data
    const locationData = await getUserLocationData();

    const userDados = {
      data: today,
      hora: today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds(),
      formulario: formulaire,
      evento: evenement,
      userID: userID,
      firstname: firstName,
      lastname: lastName,
      adressip: locationData.ip,
      paysLocalisation: locationData.country,
      villelocalisation: locationData.city,
      latitude: locationData.latitude,
      longitude: locationData.longitude
    };

    // Save log data
    await LogUtilisateursServices.create(userDados);

    return "ok";
  } catch (error) {
    console.error("Error during logUtilisateurs:", error);
    throw error; // Ensure the error is propagated
  }
}